const ScaleType = {
  WeightedAverage: "WeightedAverage",
  Contribution: "Contribution",
  Ratio: "RATIO",
  25: "25",
  50: "Median",
  75: "75",
};

export const Scan2Percentiles = [99, 97.5, 95];

export const Scan2PercentilesOptions = Scan2Percentiles.map((val) => ({
  label: val,
  value: val,
}));

export default ScaleType;

// Define custom order for scale type options with custom labels
const scaleTypeOrder = [
  { value: "Contribution", label: "Contribution" },
  { value: "WeightedAverage", label: "Weighted Average" },
  { value: "RATIO", label: "Ratio" },
  { value: "25", label: "25" },
  { value: "50", label: "Median" },
  { value: "75", label: "75" },
];

export const scaleTypeOptions = scaleTypeOrder;
